import Flex from "./Flex";
import StatusChip from "./StatusChip";
import Text from "./Text";

export type PaymentLinkInfo = {
  paymentLinkSent?: boolean;
  paymentLinkAmount?: number | string | null;
  paymentLinkPaid?: boolean;
};

/**
 * A payment link exists for the appointment once the backend flags it as sent
 * or returns the amount the link was generated for (copay or self pay).
 */
export const hasPaymentLink = (info?: PaymentLinkInfo | null) =>
  Boolean(
    info &&
    (info.paymentLinkSent ||
      (info.paymentLinkAmount !== null &&
        info.paymentLinkAmount !== undefined &&
        info.paymentLinkAmount !== ""))
  );

const formatLinkAmount = (amount?: number | string | null) => {
  if (amount === null || amount === undefined || amount === "") return "-";
  const value = Number(amount);
  return Number.isFinite(value) ? `$${value.toFixed(2)}` : "-";
};

/**
 * Amount the payment link was sent for along with its latest payment status.
 * Resending reuses the same link, so this always reflects the current record.
 *
 * @author rajkumar rathod
 */
const PaymentLinkDetails = ({
  paymentLinkAmount,
  paymentLinkPaid,
}: PaymentLinkInfo) => (
  <Flex alignItems={"center"} gap={1}>
    <Text>{formatLinkAmount(paymentLinkAmount)}</Text>
    <StatusChip
      value={Boolean(paymentLinkPaid)}
      activeLabel="Paid"
      inactiveLabel="Unpaid"
    />
  </Flex>
);

export default PaymentLinkDetails;
